import React from 'react';
import { useDispatch } from 'react-redux';
import Tour from 'reactour';
import { saveTour } from 'redux/thunks';
import './JoinCreateTeamTour.scss';

interface JoinCreateTeamTourProps {
	open: boolean;
	onClose: () => void;
}

const JoinCreateTeamTour = (props: JoinCreateTeamTourProps) => {
	const { open, onClose } = props;
	const dispatch = useDispatch();

	const tourCompleted = () => {
		dispatch(saveTour('JoinCreateTeamModalTour'));
	};

	const steps = [
		{
			selector: '.join-create__title',
			content: 'Tokens of Appreciation provides a fun and collaborative way for you to publicly recognize the contributions of your team members.',
		},
		{
			selector: '#join-create__existing-team-button',
			content: 'You have the option to join a team if it already exists',
		},
		{
			selector: '#join-create__new-team-button',
			content: 'If your team doesnt exist, you can create it and start sending tokens',
		},
		{
			selector: '.shout-out-button',
			content: () => (
				<>
					<div>Don't have a team but still want to give someone recognition? Send them a shout-out!</div>
					<div className='join-create-tour__paragraph'>A shout-out is a way to give someone recognition without being on a team with them.</div>
					<div className='join-create-tour__paragraph'>
						While shout-outs dont include tokens, you can include a message recognizing them for the work they did.
					</div>
					<div className='join-create-tour__footer'>These shout-outs will show up in every team the person is on</div>
				</>
			)
		},
	];

	return (
		<Tour
			steps={steps}
			closeWithMask={false}
			disableFocusLock={true}
			disableInteraction={true}
			showCloseButton={true}
			disableKeyboardNavigation={['esc']}
			isOpen={open}
			accentColor='#8524AA'
			lastStepNextButton={<div style={{ color: '#8524AA' }}>Get Started</div>}
			onRequestClose={onClose}
			onAfterOpen={tourCompleted}
		/>
	);
};

export default JoinCreateTeamTour;
